import { connect } from 'react-redux'
import ContextMenu from './context-menu'
import { openAgeGroupDialog } from '../../../pages/pupils/dialogs/set-age-group/set-age-group.actions'
import { openAddToGroupDialog } from '../../../add-to-group/add-to-group.actions'
import { openRemoveFromGroupDialog } from '../../../pages/pupils/dialogs/remove-from-group/remove-from-group.actions'
import { getPupil } from '../../../../stores/pupils/pupils.selectors'
import {
  retirePupil,
  incrementAgeGroup,
  addPermission,
  removePermission
} from '../../../../stores/pupils/pupils.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { withMe } from 'pobble-components/dist/pobble-user'

const mapStateToProps = (state, { id, me }) => {
  const pupil = getPupil(state, id)
  return {
    editable: me.account.policy.can_manage_students,
    canUpdatePermissions:
      me.account.policy.can_update_school_leader_permissions,
    pupilName: pupil.account.full_name,
    canPublish: pupil.policy.can_publish
  }
}

const mapDispatchToProps = dispatch => ({
  openAgeGroupDialog: ids => dispatch(openAgeGroupDialog(ids)),
  openAddToGroupDialog: ids => dispatch(openAddToGroupDialog(ids)),
  openRemoveFromGroupDialog: ids => dispatch(openRemoveFromGroupDialog(ids)),
  retirePupil: id => dispatch(retirePupil(id)).catch(errorHandler),
  addPermission: id => dispatch(addPermission(id)).catch(errorHandler),
  removePermission: id => dispatch(removePermission(id)).catch(errorHandler),
  onIncrementAge: id => dispatch(incrementAgeGroup(id)).catch(errorHandler)
})

export default withMe(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContextMenu)
)
